import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Icon,
  Menu,
  MenuList,
  MenuItem,
  ListItemText,
  ListSubheader,
  Checkbox,
  Tooltip,
  IconButton,
  Fab,
} from '@material-ui/core';
import { getTagTypes } from '@pingum/app-state-management/tagType/actions';
import { getTags } from '@pingum/app-state-management/tag/actions';
import { showLogsModal } from '@pingum/app-state-management/log/actions';
import { getTenantFromUrl } from '../../../../../utils/urlHelper';
import AuditLogsButton from '../../../../widgets/AuditLogsButton';
import styles from './styles';

export class TagSettingsHeaderComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      includeArchived: props.includeArchived,
    };
  }

  handleIncludeArchivedChanged = () => {
    this.setState((prevState) => ({ includeArchived: !prevState.includeArchived }), () => {
      this.props.getTagTypes(this.state.includeArchived);
      this.props.getTags(this.state.includeArchived);
    });
  }

  handleSettingsClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  }

  handleSettingsClose = () => {
    this.setState({ anchorEl: null });
  }

  showLogsModal = () => {
    this.props.showLogsModal({
      tenantName: getTenantFromUrl(),
      service: 'event',
      actions: ['Create Tag Category', 'Update Tag Category', 'Create Tag', 'Update Tag'],
    });
  }

  render() {
    const {
      onShowInformationModal,
      onAddTagType,
      isAddingTagType,
    } = this.props;
    const {
      anchorEl,
      includeArchived,
    } = this.state;
    return (
      <div style={styles.tagSettingsTitleContainer}>
        <h3
          style={styles.tagSettingsTitle}
          className="event-tag-page-title"
        >
          Tags
        </h3>
        <div style={styles.tagSettingsActionsContainer}>
          <Tooltip title="Add New Tag Category" id="add-new-tag-type-tooltip">
            <Fab
              disabled={isAddingTagType}
              color="primary"
              aria-label="add"
              onClick={onAddTagType}
              style={styles.addButton}
              size="medium"
            >
              <Icon>add</Icon>
            </Fab>
          </Tooltip>
          <Tooltip title="More Actions" id="tag-more-actions-tooltip">
            <IconButton
              onClick={this.handleSettingsClick}
              id="more-actions-button"
            >
              <Icon>more_vert</Icon>
            </IconButton>
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleSettingsClose}
          >
            <ListSubheader>
              More actions
            </ListSubheader>
            <MenuList>
              <MenuItem
                onClick={this.handleIncludeArchivedChanged}
                button
                id="include-archived-tag-button"
              >
                <Checkbox
                  disableRipple
                  checked={includeArchived}
                />
                <ListItemText primary="Include Archived" />
              </MenuItem>
              <MenuItem
                onClick={onShowInformationModal}
                button
                id="about-tags-button"
              >
                <IconButton disableRipple>
                  <Icon>info_outline</Icon>
                </IconButton>
                <ListItemText primary="About Tags" />
              </MenuItem>
              <MenuItem
                onClick={this.showLogsModal}
                button
                id="show-logs-button"
              >
                <AuditLogsButton />
                <ListItemText primary="View Audit Logs" />
              </MenuItem>
            </MenuList>
          </Menu>
        </div>
      </div>
    );
  }
}

TagSettingsHeaderComponent.propTypes = {
  onShowInformationModal: PropTypes.func,
  getTagTypes: PropTypes.func,
  getTags: PropTypes.func,
  includeArchived: PropTypes.bool,
  showLogsModal: PropTypes.func,
  onAddTagType: PropTypes.func,
  isAddingTagType: PropTypes.bool,
};

TagSettingsHeaderComponent.defaultProps = {
  onShowInformationModal: () => {},
  getTagTypes: () => {},
  getTags: () => {},
  includeArchived: false,
  showLogsModal: () => {},
  onAddTagType: () => {},
  isAddingTagType: false,
};

export const mapStateToProps = (state) => ({ includeArchived: state.tagType.includeArchived });

export const mapDispatchToProps = (dispatch) => ({
  getTagTypes: (includeArchived) => dispatch(getTagTypes(includeArchived, false)),
  getTags: (includeArchived) => dispatch(getTags(includeArchived, true)),
  showLogsModal: (request) => dispatch(showLogsModal(request)),
});

export default connect(
  null,
  mapDispatchToProps,
)(TagSettingsHeaderComponent);
